import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakeCVMBPATable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "ID_DF": null,
            "CPFCNPJ": null,
            "DataReferencia": null,
            "Versao": null,
            "CodigoCVM": null,
            "GrupoDFP": null,
            "Moeda": null,
            "EscalaMoeda": null,
            "OrdemExercicio": null,
            "DataFimExercicio": null,
            "CodigoConta": null,
            "DescricaoConta": null,
            "SaldoConta": null,
            "SituacaoFixaConta": null,
            "NivelConta": null,
            "BaseBalanco": null,
            "GrupoBalanco": null,
            "Ano": null,
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, ID_DF, CPFCNPJ, DataReferencia, Versao, CodigoCVM, GrupoDFP, Moeda, EscalaMoeda, OrdemExercicio, DataFimExercicio, CodigoConta, DescricaoConta, SaldoConta, SituacaoFixaConta, NivelConta, BaseBalanco, GrupoBalanco, Ano
        } = newRow

        const body = {
            "ID_DF": ID_DF,
            "CPFCNPJ": CPFCNPJ,
            "DataReferencia": DataReferencia,
            "Versao": Versao,
            "CodigoCVM": CodigoCVM,
            "GrupoDFP": GrupoDFP,
            "Moeda": Moeda,
            "EscalaMoeda": EscalaMoeda,
            "OrdemExercicio": OrdemExercicio,
            "DataFimExercicio": DataFimExercicio,
            "CodigoConta": CodigoConta,
            "DescricaoConta": DescricaoConta,
            "SaldoConta": SaldoConta,
            "SituacaoFixaConta": SituacaoFixaConta,
            "NivelConta": NivelConta,
            "BaseBalanco": BaseBalanco,
            "GrupoBalanco": GrupoBalanco,
            "Ano": Ano
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
        field: 'ID_DF',
        headerName: 'ID_DF',
        flex: 1, minWidth: 150, maxWidth: 350,
        disableColumnMenu: true,
        editable: true
        },
        {
            field: 'CPFCNPJ',
            headerName: 'CPFCNPJ',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            typeComponent: 'date',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Versao',
            headerName: 'Versao',
            type: 'number',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CodigoCVM',
            headerName: 'CodigoCVM',
            type: 'number',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'GrupoDFP',
            headerName: 'GrupoDFP',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Moeda',
            headerName: 'Moeda',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'EscalaMoeda',
            headerName: 'EscalaMoeda',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'OrdemExercicio',
            headerName: 'OrdemExercicio',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataFimExercicio',
            headerName: 'DataFimExercicio',
            typeComponent: 'date',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CodigoConta',
            headerName: 'CodigoConta',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DescricaoConta',
            headerName: 'DescricaoConta',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SaldoConta',
            headerName: 'SaldoConta',
            type: 'number',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'SituacaoFixaConta',
            headerName: 'SituacaoFixaConta',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'NivelConta',
            headerName: 'NivelConta',
            type: 'number',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'BaseBalanco',
            headerName: 'BaseBalanco',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'GrupoBalanco',
            headerName: 'GrupoBalanco',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Ano',
            headerName: 'Ano',
            type: 'number',
            flex: 1, minWidth: 150, maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakeCVMBPATable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeCVMBPATable